<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>

        <div class="card-header-actions">
          <CButton v-if="!disable"
                   class="mr-1" v-c-tooltip.hover.click="'Download Excel'" size="sm" color="info" shape="pill"
                   @click="download('Core Competency Assessment Summary by Department')"
          >
            <CIcon name="cil-cloud-download"/>
          </CButton>
          Total : {{ item.length }}
        </div>

      </CCardHeader>
      <CCardBody>

        <CRow v-if="!disable && role == 1 && item.length">
          <CCol></CCol>
          <CCol col="6">
            <CChartDoughnut
                :datasets="summaryChartData"
                :labels="summaryChartLabels"
            />
          </CCol>
          <CCol/>
        </CRow>

        <CDataTable
            :table-filter="{label:''}"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="item"
            :fields="fields"
            :items-per-page="small ? 50 : 20"
            :dark="dark"
            :loading="loading"
            pagination
            :items-per-page-select="pages"
            sorter
        >
          <template #index="{item,index}">
            <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
          </template>


          <template #completed="{item}">
            <td class="text-center" > {{ item.completed }} {{ formatPercentLabel(item.completed, item.total) }}</td>
          </template>

          <template #total="{item}">
            <td class="text-center" > {{ item.total }}</td>
          </template>

          <template #pending="{item}">
            <td class="text-center" > {{ item.pending }} {{ formatPercentLabel(item.pending, item.total) }}</td>
          </template>

          <template #doing="{item}">
            <td class="text-center" > {{ item.doing }} {{ formatPercentLabel(item.doing, item.total) }}</td>
          </template>

          <template #isNoGap="{item}">
            <td class="text-center" > {{ item.isNoGap }} {{ formatPercentLabel(item.isNoGap, item.member) }}</td>
          </template>

          <template #isGap="{item}">
            <td class="text-center" > {{ item.isGap }} {{ formatPercentLabel(item.isGap, item.member) }}</td>
          </template>

          <template #action="{item,index}">
            <td style="width: 140px">
              <CRow>
                <CCol class="text-center">
                  <CButton class="mr-1"  size="sm" color="info" v-c-tooltip.hover.click="'Open Details'" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                    <CIcon name="cil-description"/>
                  </CButton>


                  <CButton v-if="!isHris" class="mr-1"  size="sm" color="warning" v-c-tooltip.hover.click="'Download Excel'" shape="pill" variant="outline" @click="toggleDetailsAndDownload(item, index)"  >
                    <CIcon name="cil-cloud-download"/>
                  </CButton>

                </CCol>
              </CRow>
            </td>
          </template>
          <template #details="{item,index}">

            <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
              <CRow v-if="disable && item.total">
                <CCol></CCol>
                <CCol col="6">
                  <CChartDoughnut
                      :datasets="buildStatusChart(item)"
                      :labels="buildStatusChartLabels(item)"
                  />
                </CCol>
                <CCol></CCol>
              </CRow>
              <CRow v-if="!disable && item.member">
                <CCol></CCol>
                <CCol col="6">
                  <CChartDoughnut
                      :datasets="buildGapChart(item)"
                      :labels="buildGapChartLabels(item)"
                  />
                </CCol>
                <CCol/>
              </CRow>

              <CRow class="mt-3" v-if="!disable && role == 1" >
                <CCol>
                  <ReportCompetency2 class="mb-3" :item="item.explorerAgency" :loading="loading" />
                </CCol>
              </CRow>
              <CDataTable
                  :table-filter="{label:''}"
                  :fields="childrenFields"
                  :items="item.item"
                  items-per-page-select
                  :items-per-page="20"
                  hover
                  pagination
                  :items-per-page-select="pages"
                  sorter
              >
                <template #index="{item,index}">
                  <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
                </template>


                <template #competencyLevel="{item,index}">
                  <td class="text-center font-weight-bold"  @click="toggleDetails(item, index)"> {{ item.competencyLevel}}</td>
                </template>
                <template #assessment0="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment0)" @click="toggleDetails(item, index)"> {{ item.assessment0}}</td>
                </template>

                <template #assessment1="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment1)"  @click="toggleDetails(item, index)"> {{ item.assessment1}}</td>
                </template>

                <template #assessment2="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(item.competencyLevel,item.assessment2)" @click="toggleDetails(item, index)"> {{ item.assessment2}}</td>
                </template>

                <template #gapSum="{item,index}">
                  <td class="text-center font-weight-bold" :class="color(0,item.gapSum)" @click="toggleDetails(item, index)"> {{ item.gapSum }}</td>
                </template>


                <template #action="{item,index}">
                  <td style="width: 140px">
                    <CRow>
                      <CCol class="text-center">
                        <CButton class="mr-1" v-c-tooltip.hover.click="'Remove'" size="sm" color="danger" shape="pill" variant="outline" @click="onRemove(item,index)"  >
                          <CIcon name="cil-trash"/>
                        </CButton>

                      </CCol>
                    </CRow>
                  </td>
                </template>

                <template #no-items-view>
                  <div class="text-center text-muted py-4">
                    {{ loading ? 'Loading...' : 'No data available' }}
                  </div>
                </template>
              </CDataTable>
            </CCollapse>
          </template>

          <template #no-items-view>
            <div class="text-center text-muted py-4">
              {{ loading ? 'Loading...' : 'No data available' }}
            </div>
          </template>
        </CDataTable>
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import {CChartDoughnut} from '@coreui/vue-chartjs'
import ReportCompetency2 from "@/projects/views/E-Performances/Dashboard/Admin/components/ReportCompetency2";
import * as XLSX from "xlsx";

export default {
  components: {ReportCompetency2, CChartDoughnut},
  name: 'History',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    item:{
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
          {key:"title", label:"Title", },
          {key:"member", label: "Total",_style: 'width:30px; text-align: center' },

          {key:"isGap", label: "Gap found",_style: 'width:150px; text-align: center' },
          {key:"isNoGap", label: "No Gap",_style: 'width:150px; text-align: center' },
          // {key:"isMeets", label: "Meets", _style: 'width:150px; text-align: center'},
          // {key:"isExceeding", label: "Exceeding", _style: 'width:150px; text-align: center'},

          {key:"action", label: "#", _style: 'width:30px; text-align: center'}
        ]
      }
    },
    childrenFields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"year", label:"year", _style: 'width:50px; text-align: center'},
          {key:"code", label:"รหัสพนักงาน", _style: 'width:120px;'},
          {key:"info", label:"ชื่อ - นามสกุลพนักงาน" , _style: 'width:300px;'},
          {key:"cc", label:"ชื่อรายการสมรรถนะ", _style: 'width:350px;'},
          {key:"competencyLevel", label:"ระดับที่คาดหวัง",_style: 'width:120px; text-align: center' },
          {key:"assessment0", label:"ประเมินตนเอง", _style: ' width:120px; text-align: center' },
          {key:"assessment1", label:" ผู้ประเมิน 1", _style: ' width:120px; text-align: center' },
          {key:"assessment2", label:" ผู้ประเมิน 2", _style: ' width:120px; text-align: center' },
          {key:"gapSum", label:" สรุปผล", _style: ' width:120px;text-align: center' },
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    isHris: {
      type: Boolean,
      default: true
    },

    pages:{
      type: Object,
      default() {
        return {
          values:[10,20,50,100]
        }
      }
    },
    loading:{
      type: Boolean,
      default() {
        return false
      }
    },
    disable: {
      type: Boolean,
      default() {
        return false
      }
    }
  },

  data: function () {
    return {
      role:this.$store.getters['personal/profile'].role,
      collapseDuration: 0,
    }
  },

  methods: {
    toPercent(value, total) {
      if (!total) {
        return "0.00";
      }

      return ((value / total) * 100).toFixed(2);
    },

    formatPercentLabel(value, total) {
      return `( ${this.toPercent(value, total)}% )`;
    },

    splitCompetencyCode(value) {
      const [code = "-", title = "-"] = (value || "").split("-");
      return {code, title};
    },

    download(name) {
      const items = this.item.flatMap((group) => (
        (group.item || []).map((entry) => {
          const competency = this.splitCompetencyCode(entry.cc);
          return {
            'รหัสหน่วยงาน': group.code || "-",
            'หน่วยงาน': group.title,
            'รหัสพนักงาน': entry.code,
            'ชื่อ - นามสกุลพนักงาน': entry.info,
            'ปีการประเมิน (ปี พ.ศ.)': entry.year,
            'รหัสข้อมูลรายการสมรรถนะ': competency.code,
            'ชื่อรายการสมรรถนะ': competency.title,
            'ระดับที่คาดหวัง': entry.competencyLevel,
            'ประเมินตนเอง': entry.assessment0,
            'ผู้ประเมิน 1': entry.assessment1,
            'ผู้ประเมิน 2': entry.assessment2,
            'สรุปผล': entry.gapSum,
          };
        })
      ));

      const worksheet = XLSX.utils.json_to_sheet(items);
      worksheet['!cols'] = [
        { wpx: 100 }, { wpx: 170 }, { wpx: 80 }, { wpx: 170 }, { wpx: 115 }, { wpx: 136 },
        { wpx: 170 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 },
      ];

// สร้าง workbook และเพิ่ม worksheet แรก
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "All");

// บันทึกไฟล์
      XLSX.writeFile(workbook, name+".xlsx");


      // var result = item.item.map(objs => ({
      // 'รหัสพนักงาน': objs.code,
      // 'ชื่อ - นามสกุลพนักงาน': objs.info,
      // 'ปีการประเมิน (ปี พ.ศ.)': objs.year,
      // 'รหัสข้อมูลรายการสมรรถนะ': objs.cc.split("-")[0],
      // 'ชื่อรายการสมรรถนะ': objs.cc.split("-")[1],
      // 'ระดับที่คาดหวัง': objs.competencyLevel,
      // 'ประเมินตนเอง': objs.assessment0,
      // 'ผู้ประเมิน 1': objs.assessment1,
      // 'ผู้ประเมิน 2': objs.assessment2,
      // 'สรุปผล': objs.gapSum
      // }));


    },
    downloads(name) {

      var objs = this.item

      var objsArray = [];
      for(var i=0; i<objs.length; i++){
        var objCC = [];

        var data = {};
        data.code = objs[i].code;
        data.title = objs[i].title;
        data.tital = objs[i].member;
        data.gapFound = objs[i].isGap + ' ( ' + ((objs[i].isGap / objs[i].total) * 100).toFixed(2) + '% )' ;
        data.noFound = objs[i].isNoGap + ' ( ' + ((objs[i].isNoGap / objs[i].total) * 100).toFixed(2) + '% )' ;


        for(var j=0; j<objs[i].explorerAgency.length; j++){
          var objsExplorer = {};
          objsExplorer.title = objs[i].explorerAgency[j].title
          objsExplorer.total = objs[i].explorerAgency[j].total
          objsExplorer.gapFound = objs[i].explorerAgency[j].isGap + ' ( ' + ((objs[i].explorerAgency[j].isGap / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.noFound = (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) + ' ( ' + (( (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isMeets = objs[i].explorerAgency[j].isMeets + ' ( ' + ((objs[i].explorerAgency[j].isMeets / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isExceeding = objs[i].explorerAgency[j].isExceeding + ' ( ' + ((objs[i].explorerAgency[j].isExceeding / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;

          objCC.push(objsExplorer)

        }
        data.history = objCC;

        objsArray.push(data)
      }

      const wb = XLSX.utils.book_new()
      for(var i=0; i<objsArray.length; i++){
        var nameSheet = objsArray[i].code.toString()


        const summary = [
          { Title: objsArray[i].title, Total: objsArray[i].total, GapFound: objsArray[i].gapFound, NoGap: objsArray[i].noFound },
        ];

        // ข้อมูลย่อย (จาก history)
        const details = objsArray[i].history.map((historyItem) => ({
          Title: historyItem.title,
          Total: historyItem.total,
          GapFound: historyItem.gapFound,
          NoGap: historyItem.noFound,
          Meets: historyItem.isMeets,
          Exceeding: historyItem.isExceeding,
        }));

        const sheetData = [{ Title: "Title", Total: "Total", GapFound: "Gap found", NoGap: "No Gap"},...summary, {},{ Title: "Title", Total: "Total", GapFound: "Gap found", NoGap: "No Gap", Meets: "Meets", Exceeding: "Exceeding" }, ...details]

        // แปลงข้อมูลเป็น sheet
        const sheet = XLSX.utils.json_to_sheet(sheetData, { skipHeader: true });


        // const dataX = XLSX.utils.json_to_sheet(objsArray[i].history)
        sheet['!cols'] = [
          { wpx: 500 }, // Title
          { wpx: 80 },  // Total
          { wpx: 100 }, // Gap found
          { wpx: 100 }, // No Gap
          { wpx: 100 }, // Meets
          { wpx: 100 }, // Exceeding
        ];
        XLSX.utils.book_append_sheet(wb, sheet, nameSheet)
      }
      XLSX.writeFile(wb,name+'.xlsx')
    },

    buildStatusChart(item){
      return  [{
        backgroundColor: [
          '#636f83',
          '#f9b115',
          '#2eb85c',
        ],
        data: [
          this.toPercent(item.pending, item.total),
          this.toPercent(item.doing, item.total),
          this.toPercent(item.completed, item.total)
        ]
      }]
    },

    buildStatusChartLabels(item) {
      const chart = this.buildStatusChart(item)[0].data;
      return [
        `ยังไม่ได้ประเมิน ( ${chart[0]}% )`,
        `อยู่ระหว่างประเมิน ( ${chart[1]}% )`,
        `ประเมินเสร็จสิ้น( ${chart[2]}% )`
      ];
    },

    buildGapChart(item){
      return  [{
        backgroundColor: [
          '#2eb85c',
          '#DD1B16',
        ],
        data: [
          this.toPercent(item.isNoGap, item.member),
          this.toPercent(item.isGap, item.member)
        ]
      }]
    },

    buildGapChartLabels(item) {
      const chart = this.buildGapChart(item)[0].data;
      return [
        `No Gap ( ${chart[0]}% )`,
        `Gap found ( ${chart[1]}% )`
      ];
    },

    buildSummaryChartData(items){
      const isGap = items.reduce((old, entry) => old + (entry.isGap || 0), 0);
      const isNoGap = items.reduce((old, entry) => old + (entry.isNoGap || 0), 0);
      const isMember = items.reduce((old, entry) => old + (entry.member || 0), 0);

      return  [{
        backgroundColor: [
          '#2eb85c',
          '#DD1B16',
        ],
        data: [
          this.toPercent(isNoGap, isMember),
          this.toPercent(isGap, isMember)
        ],
        value:[isNoGap, isGap]
      }]
    },

    buildSummaryChartLabels(items) {
      const chart = this.buildSummaryChartData(items)[0];
      return [
        `No Gap : ${chart.value[0]} ( ${chart.data[0]}% )`,
        `Gap found  : ${chart.value[1]} ( ${chart.data[1]}% )`
      ];
    },


    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})
      // this.$emit('info',item)
    },

    toggleDetailsAndDownload(item,index) {
      const result = item.item.map((entry) => {
        const competency = this.splitCompetencyCode(entry.cc);
        return {
          'รหัสหน่วยงาน': item.code || "-",
          'หน่วยงาน': item.title || "-",
          'รหัสพนักงาน': entry.code,
          'ชื่อ - นามสกุลพนักงาน': entry.info,
          'ปีการประเมิน (ปี พ.ศ.)': entry.year,
          'รหัสข้อมูลรายการสมรรถนะ': competency.code,
          'ชื่อรายการสมรรถนะ': competency.title,
          'ระดับที่คาดหวัง': entry.competencyLevel,
          'ประเมินตนเอง': entry.assessment0,
          'ผู้ประเมิน 1': entry.assessment1,
          'ผู้ประเมิน 2': entry.assessment2,
          'สรุปผล': entry.gapSum
        };
      });

      const worksheet = XLSX.utils.json_to_sheet(result);
      worksheet['!cols'] = [
        { wpx: 100 }, { wpx: 170 }, { wpx: 80 }, { wpx: 170 }, { wpx: 115 }, { wpx: 136 },
        { wpx: 170 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 }, { wpx: 80 },
      ];

// สร้าง workbook และเพิ่ม worksheet แรก
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, item.code+"");

// คำนวณผลสรุป
      const result1 = Array.from({ length: Math.ceil(result.length / 7) }, (_, i) => {
        const subset = result.slice(i * 7, (i + 1) * 7);
        const summary = subset.map(obj => obj['สรุปผล']);

        return {
          'รหัสพนักงาน': subset[0]['รหัสพนักงาน'],
          'ชื่อ - นามสกุลพนักงาน': subset[0]['ชื่อ - นามสกุลพนักงาน'],
          'ประเมินตนเอง': subset[0]['ประเมินตนเอง'],
          'ระดับที่คาดหวัง': subset[0]['ระดับที่คาดหวัง'],
          'ตรงตามความคาดหวัง': summary.every(val => val === 0) ? 1 : 0,
          'สูงกว่าความคาดหวัง': summary.every(val => val > 0) ? 1 : 0,
          'ต่ำกว่าตามความคาดหวัง': summary.some(val => val !== 0 && val <= 0) ? 1 : 0
        };
      });

      const worksheet1 = XLSX.utils.json_to_sheet(result1);
      worksheet1['!cols'] = [
        { wpx: 80 }, { wpx: 170 }, { wpx: 100 }, { wpx: 100 }, { wpx: 130 },{ wpx: 130 },{ wpx: 130 },
      ];

// เพิ่ม worksheet ที่สองเข้าไปใน workbook เดิม
      XLSX.utils.book_append_sheet(workbook, worksheet1, item.code+"1");

// บันทึกไฟล์
      XLSX.writeFile(workbook, item.title+".xlsx");


    },

    onRemove(item,index) {
      var body = {};
      body._id = item._id;

      this.$store.dispatch("assessment/remove",body)
    },

    color(level,checck){
      if(level > checck){
        return "text-danger"
      }else if(level == checck){
        return "text-success"
      }else{
        return "text-info"
      }

    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    }),
    summaryChartData() {
      return this.buildSummaryChartData(this.item);
    },
    summaryChartLabels() {
      return this.buildSummaryChartLabels(this.item);
    }
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
